const initialState = {
  loading: false,
  error: null,
  success: false,
};

const delegateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "POST_DELEGATE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case "POST_DELEGATE_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        data: action.payload,
      };
    case "POST_DELEGATE_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };
    default:
      return state;
  }
};

export default delegateReducer;
